export default __webpack_public_path__ + "static/form-terceirizacao-background-76564ad620d7a0fd32b98b98f8700027.jpg";